var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 32,
    cy: 48.0645,
    r: 3.125,
    fill: "#A7CC46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.752C0 15.0641 14.3145 0.751953 32 0.751953C49.6879 0.751953 64 15.0665 64 32.752C64 50.4398 49.6855 64.752 32 64.752C14.3121 64.752 0 50.4375 0 32.752ZM5 32.752C5 47.6761 17.0779 59.752 32 59.752C46.9241 59.752 59 47.6741 59 32.752C59 17.8278 46.9221 5.75195 32 5.75195C17.0759 5.75195 5 17.8298 5 32.752Z",
    fill: "#A7CC46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M32 16.8145C26.486 16.8145 22 21.3005 22 26.8145C22 28.1952 23.1193 29.3145 24.5 29.3145C25.8807 29.3145 27 28.1952 27 26.8145C27 24.0575 29.243 21.8145 32 21.8145C34.757 21.8145 37 24.0575 37 26.8145C37 29.5715 34.757 31.8145 32 31.8145C30.6193 31.8145 29.5 32.9337 29.5 34.3145V40.5645C29.5 41.9452 30.6193 43.0645 32 43.0645C33.3807 43.0645 34.5 41.9452 34.5 40.5645V36.4981C38.8083 35.3852 42 31.4656 42 26.8145C42 21.3005 37.514 16.8145 32 16.8145Z",
    fill: "#A7CC46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.bd1572ecc1aa613a2d00e03bddf608ef.svg";
export { ForwardRef as ReactComponent };